export enum CHANNEL {
  VOICE = 'VOICE',
  SMS = 'SMS',
}
